import { render, staticRenderFns } from "./NotificationsLoader.vue?vue&type=template&id=c8285630&scoped=true&"
import script from "./NotificationsLoader.vue?vue&type=script&lang=js&"
export * from "./NotificationsLoader.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsLoader.vue?vue&type=style&index=0&id=c8285630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8285630",
  null
  
)

export default component.exports